import * as amplitude from "@amplitude/analytics-browser";

// check env
const apiKey = process.env.REACT_APP_ENV === "development" || process.env.REACT_APP_ENV === "staging"
    ? "76aa9ec6ab2a9b32ae70ac667194a5d5"
    : "f61432fb31d76a3665afb482fa5eeb96";

amplitude.init(apiKey, {
    defaultTracking: {
        attribution: false,
        pageViews: true,
        sessions: true,
        formInteractions: false,
        fileDownloads: true,
    },
});

export const amplitudeActions = {
    identify: (id) => {
        amplitude.setUserId(id);
    },
    track: (name, props) => {
        amplitude.track(name, props);
    },
};